// Embedded entry point - minimal bootstrap
// Detects anchor type and loads appropriate code
// HIDDEN-only deployments: ~500 bytes (no visual anchor code)
// Visual anchors: lazy loads visual-anchors-entry.jsx (~1KB)

import { HiddenAnchor } from './vanilla/hidden-anchor';

// Initialize embedded mode with minimal footprint
export function initEmbedded() {
  // Check for HIDDEN container first (most common for embedded)
  const hiddenContainer = document.querySelector('.compatio-builder-container');
  if (hiddenContainer) {
    // Initialize vanilla JS hidden anchor (bundled in embedded chunk)
    new HiddenAnchor();
  }

  // Check if ANY visual anchors exist on the page
  const hasVisualAnchors =
    document.querySelector('#sb3-container') ||
    document.querySelector('#compatio-sb3-button') ||
    document.querySelector('[compatio-builder]');

  // Only load visual anchor code if visual containers detected
  // This prevents loading ~1KB of Preact/CSS code for HIDDEN-only deployments
  if (hasVisualAnchors) {
    import(
      /* webpackChunkName: "visual-anchors" */
      './visual-anchors-entry'
    ).then(module => {
      module.initVisualAnchors();
    }).catch(error => {
      console.error('Failed to load visual anchors:', error);
    });
  }
}

// Auto-initialize on load
initEmbedded();